import { render, staticRenderFns } from "./EvaluationCriteriaForm.vue?vue&type=template&id=1c87ebb9&scoped=true"
import script from "./EvaluationCriteriaForm.vue?vue&type=script&lang=js"
export * from "./EvaluationCriteriaForm.vue?vue&type=script&lang=js"
import style0 from "./EvaluationCriteriaForm.vue?vue&type=style&index=0&id=1c87ebb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c87ebb9",
  null
  
)

export default component.exports